import React from 'react';
import { invoiceTemplates } from './thymeleafTemplates';

export interface GjsComponent {
  id: string;
  label: string;
  category: string;
  content: string;
  media?: string;
  activate?: boolean;
  select?: boolean;
  resetBlock?: boolean;
  block?: any;
}

export const invoiceComponents: Record<string, GjsComponent[]> = {
  'Invoice Elements': [
    {
      id: 'invoice-header',
      label: 'Invoice Header',
      category: 'Invoice Elements',
      content: invoiceTemplates.invoiceHeader,
      media: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/></svg>`
    },
    {
      id: 'client-details',
      label: 'Client Details',
      category: 'Invoice Elements',
      content: invoiceTemplates.clientDetails,
      media: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z"/></svg>`
    },
    {
      id: 'invoice-resume',
      label: 'Invoice Resume',
      category: 'Invoice Elements',
      content: invoiceTemplates.invoiceResume,
      media: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M3,3H21V5H3V3M3,7H21V9H3V7M3,11H21V13H3V11M3,15H21V17H3V15M3,19H21V21H3V19Z"/></svg>`
    },
    {
      id: 'products-table',
      label: 'OrderItems Table',
      category: 'Invoice Elements',
      content: invoiceTemplates.productsTable,
      media: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M3,3H21V5H3V3M3,7H21V9H3V7M3,11H21V13H3V11M3,15H21V17H3V15M3,19H21V21H3V19Z"/></svg>`
    },
    {
      id: 'invoice-price-resume',
      label: 'Invoice Price Resume',
      category: 'Invoice Elements',
      content: invoiceTemplates.invoicePriceResume,
      media: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M7,15H9C9,16.08 10.37,17 12,17C13.63,17 15,16.08 15,15C15,13.9 13.96,13.5 11.76,12.97C9.64,12.44 7,11.78 7,9C7,7.21 8.47,5.69 10.5,5.18V3H13.5V5.18C15.53,5.69 17,7.21 17,9H15C15,7.92 13.63,7 12,7C10.37,7 9,7.92 9,9C9,10.1 10.04,10.5 12.24,11.03C14.36,11.56 17,12.22 17,15C17,16.79 15.53,18.31 13.5,18.82V21H10.5V18.82C8.47,18.31 7,16.79 7,15Z"/></svg>`
    },
    {
      id: 'amount-in-words',
      label: 'Amount in Words',
      category: 'Invoice Elements',
      content: invoiceTemplates.amountInWords,
      media: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M12,6A6,6 0 0,0 6,12A6,6 0 0,0 12,18A6,6 0 0,0 18,12A6,6 0 0,0 12,6M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8Z"/></svg>`
    },
    {
      id: 'invoice-footer',
      label: 'Invoice Footer',
      category: 'Invoice Elements',
      content: invoiceTemplates.invoiceFooter,
      media: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M12,6A6,6 0 0,0 6,12A6,6 0 0,0 12,18A6,6 0 0,0 18,12A6,6 0 0,0 12,6M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8Z"/></svg>`
    },
    {
      id: 'company-logo',
      label: 'Company Logo',
      category: 'Invoice Elements',
      content: invoiceTemplates.companyLogo,
      media: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8.5,13.5L11,16.5L14.5,12L19,18H5M21,19V5C21,3.89 20.1,3 19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19Z"/></svg>`
    },
    {
      id: 'company-name',
      label: 'Company Name',
      category: 'Invoice Elements',
      content: invoiceTemplates.companyName,
      media: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12,7V3H2V21H22V7H12M6,19H4V17H6V19M6,15H4V13H6V15M6,11H4V9H6V11M6,7H4V5H6V7M10,19H8V17H10V19M10,15H8V13H10V15M10,11H8V9H10V11M10,7H8V5H10V7M14,19H12V17H14V19M14,15H12V13H14V15M14,11H12V9H14V11M14,7H12V5H14V7M18,19H16V17H18V19M18,15H16V13H18V15M18,11H16V9H18V11M18,7H16V5H18V7Z"/></svg>`
    },
    {
      id: 'invoice-type',
      label: 'Invoice Type',
      category: 'Invoice Elements',
      content: invoiceTemplates.invoiceType,
      media: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"/></svg>`
    },
    {
      id: 'client-info-box',
      label: 'Client Info Box',
      category: 'Invoice Elements',
      content: invoiceTemplates.clientInfoBox,
      media: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"/></svg>`
    },
    {
      id: 'invoice-number-box',
      label: 'Invoice Number Box',
      category: 'Invoice Elements',
      content: invoiceTemplates.invoiceNumberBox,
      media: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"/></svg>`
    },
    {
      id: 'date-box',
      label: 'Date Box',
      category: 'Invoice Elements',
      content: invoiceTemplates.dateBox,
      media: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"/></svg>`
    },
    {
      id: 'client-number-box',
      label: 'Client Number Box',
      category: 'Invoice Elements',
      content: invoiceTemplates.clientNumberBox,
      media: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"/></svg>`
    }
  ]
};
